<bfx-blotter-ops-int-top-menu></bfx-blotter-ops-int-top-menu>
<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    [frameworkComponents]="frameworkComponents"
    enableColResize
    enableSorting
    rowHeight="22"
    (mouseup)="onMouseUp($event)"
    multiSortKey="ctrl"
    ><!-- OMS-34847 no column selector (contextmenu)="handleClick($event)" > -->
  </ag-grid-angular>
</div>
<bfx-blotter-ops-int-context-menu
  *ngIf="!embeddedTableMode"
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-ops-int-context-menu>
<bfx-blotter-column-selector
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-column-selector>
